import React from "react";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "../../components/ui/Table";
import { formatDateTime, languageName } from "../../utils/helpers";
import { KIND_LABELS } from "../translations/TranslationRow";

const JOB_LABELS = {
  translation_backfill: "corpus run",
  "enrich:translation": "nightly pass",
  enrich: "nightly pass",
  pipeline: "nightly pass",
};

/**
 * Translation coverage per language and field family (#692), as the latest translation run
 * measured it: the share of active events whose texts are all translated (or need no translation).
 * Each language's launch gate. Never measured on this page's request, so it says when it was.
 */
export function TranslationCoverage({ latest }) {
  const locales = Object.entries(latest?.coverage?.locales ?? {});
  return (
    <div>
      <p className="mb-2 text-sm font-medium text-muted-foreground">Translation coverage</p>
      {!locales.length ? (
        <p className="text-sm text-muted-foreground">No translation run has measured it yet.</p>
      ) : (
        <>
          <Table>
            <TableHeader>
              <TableRow>
                <TableHead>Language</TableHead>
                {Object.entries(KIND_LABELS).map(([kind, label]) => (
                  <TableHead key={kind}>{label}</TableHead>
                ))}
              </TableRow>
            </TableHeader>
            <TableBody>
              {locales.map(([locale, families]) => (
                <TableRow key={locale}>
                  <TableCell>{languageName(locale)}</TableCell>
                  {Object.keys(KIND_LABELS).map((kind) => {
                    const family = families[kind];
                    return (
                      <TableCell key={kind}>
                        {family?.total ? (
                          <>
                            <span className="font-semibold">{family.percent}%</span>{" "}
                            <span className="text-xs text-muted-foreground">
                              {family.covered.toLocaleString()} / {family.total.toLocaleString()}
                            </span>
                          </>
                        ) : (
                          <span className="text-muted-foreground">—</span>
                        )}
                      </TableCell>
                    );
                  })}
                </TableRow>
              ))}
            </TableBody>
          </Table>
          <p className="mt-1 text-xs text-muted-foreground">
            Active events whose texts are all translated or need none. Measured{" "}
            {formatDateTime(latest.coverage.computed_at)} by the {JOB_LABELS[latest.job_type] ?? latest.job_type}.
          </p>
        </>
      )}
    </div>
  );
}
